export default __webpack_public_path__ + "assets/img/process_loader-5.c7cce4dd.gif";